import { render } from "./AdminNotificationPanel.vue?vue&type=template&id=1ca1a637&scoped=true"
import script from "./AdminNotificationPanel.vue?vue&type=script&lang=js"
export * from "./AdminNotificationPanel.vue?vue&type=script&lang=js"

import "./AdminNotificationPanel.vue?vue&type=style&index=0&id=1ca1a637&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca1a637"]])

export default __exports__